import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { KSK2120_R01Dto } from "./Dto_KSK2120_R01";
import { KSK2120_R01Filter } from "./Store_KSK2120_R01";

const baseUrl = `${config.apiUrl}/KSK2120_R01`;

const getParams = (filter: Partial<KSK2120_R01Filter>, listLength?: number) => {
	return {
		// pastWorkNo: filter.pastWorkNo,
		nowWorkNo: filter.nowWorkNo,
		pastInfoFetch: filter.pastInfoFetch,
	}
}

export const getKSK2120_R01List = async (option: string, params: Partial<KSK2120_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<KSK2120_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const postKSK2120_R01 = async (data: KSK2120_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<KSK2120_R01Dto[], ResponseDto<KSK2120_R01Dto[]>>(url, data);
}

export const patchKSK2120_R01 = async (data: KSK2120_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<KSK2120_R01Dto[], ResponseDto<KSK2120_R01Dto[]>>(url, data);
}